<script setup lang="ts">
import Button from '@/core/components/base/Button.vue'
import LanguageView from '@/core/components/LanguageView.vue'
import { useButtonIndex, useButtonIndexMock } from './ButtonIndex'

const { doShowOverviewContent } = useButtonIndex()

function handleTap(event: PointerEvent) {
  doShowOverviewContent()
}
</script>

<template>
  <LanguageView lang="th">
    <Button class="button-index" @tap="handleTap">
      <img src="/images/simakatra/th/button-index.png" />
    </Button>
  </LanguageView>

  <LanguageView lang="en">
    <Button class="button-index en" @tap="handleTap">
      <img src="/images/simakatra/en/button-index.png" />
    </Button>
  </LanguageView>
</template>

<style scoped>
.button-index {
  position: absolute;
  left: 860px;
  top: 989px;
}
</style>
